// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fk","advertDetailHeaderLocation__value":"c-m_fl"};